/**
 * Cálculos unificados del control horario.
 *
 * Fuente única de verdad: el campo `total_trabajado_s` / `total_pausa_s`
 * que devuelve el endpoint `GET /api/time-clock/today`. El backend ya
 * incluye, para el día actual:
 *   - el tiempo desde la entrada hasta `now()` del servidor,
 *   - las pausas cerradas,
 *   - la pausa abierta hasta `now()` cuando aplica,
 *   - y aplica la zona horaria configurada.
 *
 * Estas funciones NO recomputan nada en cliente para evitar
 * discrepancias entre el reloj de la cabecera (Layout) y el bloque
 * "Trabajado" de la página /time-clock. Ambos consumidores deben
 * obtener exactamente el mismo número.
 *
 * Reglas garantizadas (extraídas del spec):
 *  1-7. Resueltas íntegramente en el backend (ver `_compute_day`).
 *
 * @param {object|null|undefined} summary  Respuesta de GET /api/time-clock/today
 * @param {number} _nowMs                  (deprecated, no usado) compatibilidad
 * @returns {number}                       Segundos trabajados hoy.
 */
// eslint-disable-next-line no-unused-vars
export function workedTodaySeconds(summary, _nowMs = Date.now()) {
  return Number(summary?.total_trabajado_s || 0);
}

/**
 * Segundos de pausa acumulados hoy. Misma filosofía: lee directo del
 * backend, sin recomputación en cliente.
 *
 * @param {object|null|undefined} summary
 * @param {number} _nowMs   (deprecated, no usado)
 * @returns {number}
 */
// eslint-disable-next-line no-unused-vars
export function pausedTodaySeconds(summary, _nowMs = Date.now()) {
  return Number(summary?.total_pausa_s || 0);
}
